import { useOperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";
import { Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

type TrainTypeDisplayProps = {
  eventType: string;
};

export const TrainTypeDisplay: FC<TrainTypeDisplayProps> = ({ eventType }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { data, isError, isPending } = useOperationalInformationTypes(t);
  if (isError) return <FailureMessage />;
  if (isPending) return <SkeletonLoader skeletonType="trainSeries" />;
  const label =
    eventType === "TRAIN_GENERAL_INFO" || eventType === "TRAIN_GENERAL_WARNING"
      ? t("Egendefinert hendelse")
      : data.events?.find((it) => it.type === eventType)?.label;
  return (
    <Text variant="sm" fontWeight={700} color={theme.colorTextMain}>
      {label}
    </Text>
  );
};
